import * as React from "react";
import { Dimension } from "reducers/dimensions-panel/dimensions-panel";
import { DimensionCheckBoxState } from "../../dimension-types";
import { SelectedDimension, useDimensionPanelContext } from "../../dimensions-tool-panel";
import { connect } from "react-redux";
import { IStore } from "reducers";
import { DimensionPanelDefaultAction } from "actions/tool-panel/draft/types";
import { selectAllValues } from "actions/tool-panel/draft/actions";
import { List } from "@material-ui/core";
import { DoorsTabCard } from "./doors-tab-card";
import { DoorsTabToolbar } from "./doors-tab-toolbar";

type ReduxProps = {
    dimensions: Dimension[];
    selectAllValuesAction: DimensionPanelDefaultAction;
    capabilities: nuorder.folder.v1.Capabilities;
};

type DoorsTabOwnProps = {
    setSelectedDimension: React.Dispatch<React.SetStateAction<SelectedDimension>>;
};

type DoorsTabProps = DoorsTabOwnProps & ReduxProps;

export const DoorsTab: React.FC<DoorsTabProps> = ({
    setSelectedDimension,
    dimensions,
    selectAllValuesAction,
    capabilities,
}) => {
    const dimensionCardClickHandler = (id: string, label: string, index) => {
        setSelectedDimension({
            id,
            label,
            kind: "dimensions",
            index,
        });
    };

    const { isRollupMode } = useDimensionPanelContext();
    const shouldRenderDoorAttributesToolbar = !isRollupMode && capabilities?.can_trash;

    return (
        <>
            {shouldRenderDoorAttributesToolbar && <DoorsTabToolbar />}
            <List>
                {dimensions.map(({ id, name, selected, values }, dimensionIndex) => (
                    <DoorsTabCard
                        checkboxState={
                            dimensionIndex === 0 ? DimensionCheckBoxState.Disabled : DimensionCheckBoxState.On
                        }
                        selected={selected}
                        dimensionId={id}
                        dimensionValuesCount={values.length}
                        selectedDimensionValuesCount={values.reduce(
                            (count, value) => (value.selected ? count + 1 : count),
                            0
                        )}
                        onToggleSelect={() => selectAllValuesAction({ selectionKind: "dimensions", dimensionIndex })}
                        key={id}
                        label={name}
                        selectDimensionHandler={() => dimensionCardClickHandler(id, name, dimensionIndex)}
                    />
                ))}
            </List>
        </>
    );
};

export const DoorsTabContainer = connect(
    (state: IStore) => ({
        dimensions: state.dimensionsPanel.draft.dimensions,
        capabilities: state.collection?.driveItem?.capabilities,
    }),
    { selectAllValuesAction: selectAllValues }
)(DoorsTab) as unknown as React.FC<DoorsTabOwnProps>;
